import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { AppVersion } from '../../components/AppVersion.js';
import { Brand } from '../../components/Brand.js';
import { LegalLinks } from '../../components/LegalLinks.js';
import { SignupLink } from '../../components/SignupLink.js';

/**
 * The chrome every page that is not the landing page shares.
 *
 * Same header, footer and closing call to action as `/`, so a visitor arriving
 * from a search result on a comparison page lands somewhere that is obviously
 * the same product, with the same way out of it.
 *
 * These pages are public and never gated: they exist to be the first thing a
 * stranger sees.
 */
export function MarketingPage({
  eyebrow,
  heading,
  lede,
  children,
}: {
  eyebrow: string;
  heading: string;
  lede: string;
  children: ReactNode;
}) {
  return (
    <div className="landing">
      <header className="landing-header">
        <Brand to="/" />
        <nav className="landing-nav" aria-label="Account">
          <Link to="/signin">Sign in</Link>
          <SignupLink className="button" slot="nav">
            Get started
          </SignupLink>
        </nav>
      </header>

      <section className="landing-act marketing-head">
        <div className="landing-act-inner">
          <p className="eyebrow">{eyebrow}</p>
          <h1>{heading}</h1>
          <p className="landing-lede">{lede}</p>
        </div>
      </section>

      {children}

      <section className="landing-act landing-close">
        <div className="landing-act-inner">
          <h2>Put a question in front of the room.</h2>
          <div className="landing-cta">
            <SignupLink className="button" slot="footer">
              Get started
            </SignupLink>
            <Link to="/signin" className="landing-cta-quiet">
              Sign in
            </Link>
          </div>
          <p className="landing-price">
            Free for a room of up to 100. Paid plans stop counting rather than counting higher.
          </p>
        </div>
      </section>

      <footer className="landing-footer">
        <LegalLinks />
        <AppVersion />
      </footer>
    </div>
  );
}
